<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import SidebarLayout from '@/layout/SidebarLayout.vue';
import SecurityTrim from '@/components/ui/SecurityTrim.vue';
import IdSearchHeader from '@/components/ui/IdSearchHeader.vue';
import CardDetailPanel from '@/components/cards/CardDetailPanel.vue';
import CardTokenTable from '@/components/card-tokens/CardTokenTable.vue';
import { useCardSearches } from '@/components/cards/cardSearches';
import { CardActions, CardTokenActions } from '@/integrations/Immersve/auth/actions';
import { useAuthStore } from '@/stores/auth.store';

const route = useRoute();
const authStore = useAuthStore();
const searches = useCardSearches();

const cardId = computed(() => route.params.cardId as string);
const canReadCard = computed(() => authStore.user?.isAuthorised(CardActions.Read) ?? false);
const canReadCardTokens = computed(
  () => authStore.user?.isAuthorised(CardTokenActions.Read) ?? false
);
</script>

<template>
  <SidebarLayout>
    <!-- The page's two blocks each need their own permission, so either lets
    the user in and each block shows only with its own. The card's account is
    unknown until it is loaded, so both are asked for on any account; amethyst
    checks them against the card's own. -->
    <SecurityTrim :actions="[CardActions.Read, CardTokenActions.Read]" account-id="*" match="any">
      <div class="px-4 py-6 md:px-8" data-test="screen-card">
        <IdSearchHeader :searches="searches" />
        <CardDetailPanel v-if="canReadCard" :card-id="cardId" />
        <section v-if="canReadCardTokens" class="mt-12" data-test="card-tokens-section">
          <h2 class="mb-3 text-base/7 font-semibold text-gray-900">Tokens</h2>
          <CardTokenTable :card-id="cardId" />
        </section>
      </div>
    </SecurityTrim>
  </SidebarLayout>
</template>
